export const QUERY_PERMIT_HEARTBEAT_MS = 30_000;
export const QUERY_PERMIT_LIVENESS_THRESHOLD_MS = 60_000;
export const QUERY_PERMIT_LIVENESS_SWEEP_MS = 15_000;
export const QUERY_PERMIT_MAX_HOLD_MS = 90_000;
// Max concurrent /api/query/* requests across all tabs of the origin. Sized for one
// dashboard's load burst: 10 permits for the slow main queries (matches the app's own
// DEFAULT_QUERY_CONCURRENCY / MAX_CARDS_TO_LOAD_IMMEDIATELY = 10 in
// iron/common/report/dashboards/query-concurrency.ts), plus ~3 slots for the faster
// requests (the per-card query_metadata calls + a couple upfront properties/events
// requests). Those run ~4x faster than the main query (median ~106ms vs ~439ms) so they
// free their permit long before a main query finishes and don't each need a dedicated
// slot; ~3 slots absorb them by time-weight (12 fast requests x ~0.24 occupancy).
export const QUERY_PERMIT_GLOBAL_CAP = 13;
// Reduced caps for projects with constrained backends, mirroring the LIMITED /
// VERY_LIMITED tiers in getMaxConcurrentQueries (iron/common/report/dashboards/
// query-concurrency.ts). Unlike the default cap above, these are the *raw* per-project
// concurrency limits with no padding for the faster query_metadata calls or the slower
// initial properties/events queries — over-provisioning is too risky for these backends,
// so they get exact parity with their dashboard concurrency limit instead. Resolution
// lives tab-side in client.ts (getQueryPermitGlobalCap), where the project-config
// constants live; the worker just sizes each pool from the cap it's given.
export const QUERY_PERMIT_LIMITED_CAP = 5;
export const QUERY_PERMIT_VERY_LIMITED_CAP = 2;

export type TabToWorkerMessage =
  | {type: `acquire`; reqId: string; projectId: string; cap: number}
  | {type: `release`; reqId: string}
  | {type: `heartbeat`};

export type WorkerToTabMessage = {type: `granted`; reqId: string} | {type: `reclaimed`; reqId: string};
